export const LOADING_MESSAGE = 'Loading redirect data...';

export const NO_ACTIVE_DOMAIN_MESSAGE = 'No active domain found.';

export const DEFAULT_DISMISSIBLE_MESSAGE_DELAY = 8000;
